import { Component, computed, input } from '@angular/core';
import { DialogService } from '@app/shared/dialog/dialog.service';
import { PortalTimeAgoPipe } from '@app/shared/pipes/portal-time-ago.pipe';
import { SharedModule } from '@app/shared/shared.module';
import { currentLanguage } from '@app/utils/translate';
import { NotificationDialogComponent } from '@business/notification/components/notification-dialog/notification-dialog.component';
import { MyPortalNotificationViewModel } from '@business/notification/models/my-portal-notifications-view-model';
import { getTranslationsByKey } from '@business/notification/models/portal-notification-helpers';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'portal-my-notifications-dropdown-item',
  standalone: true,
  imports: [PortalTimeAgoPipe, SharedModule, TranslateModule],
  templateUrl: './my-notifications-dropdown-item.component.html',
  styles: ``,
})
export class MyNotificationsDropdownItemComponent {
  notification = input.required<MyPortalNotificationViewModel>();
  language = currentLanguage();
  title = computed(() => getTranslationsByKey(this.notification().titles, this.language()).title);

  constructor(private dialogService: DialogService) {}

  openNotificationDialog(): void {
    this.dialogService.open(NotificationDialogComponent).withInput({
      notificationId: this.notification().id,
      publicationDate: this.notification().publishedAt,
      translations: this.notification()._original.translations,
      type: this.notification().type,
    });
  }
}
